import React from 'react';

// Modules
import PublicTopBar from '../publicTopBar/PublicTopBar';
import CompetitorsList from '../shared/competitorsList/CompetitorsList';
import SwitchingsList from '../shared/switchingsList/SwitchingsList';
import ScheduleContainer from '../shared/schedule/ScheduleContainer';
import RegistrationForm from '../shared/registrationForm/RegistrationForm';
import { Divider, Tabs, Modal, Button } from 'antd';

// Style
import './Champ.css';

import weigthTableImg from '../img/tabelaPesos.png';

export default (props) => {
    return (
        <div>
            <PublicTopBar />

            <div className='champImgBg' style={{ backgroundImage: `url(${props.champ && props.champ.img})` }} />

            <div className='champCentralDiv'>
                <h4>{props.champ && props.champ.nome}</h4>

                <p>
                    <b style={{ fontSize: 'larger' }}>{props.champ && props.champ.descricao}</b>
                </p>

                <Divider />

                <p>
                    {props.champ && props.champ.observacao}
                </p>

                <p>
                    {props.champ && props.champ.doc ?
                        <a href={props.champ.doc} target='blank'>Edital do campeonato</a> :
                        null
                    }
                </p>

                {props.champ && props.champ.registrationStatus !== 'finish' ?
                    <Button
                        type='primary'
                        style={{ marginRight: '10px' }}
                        onClick={() => props.openModalRegistration()}
                    >Se inscreva</Button>
                    : null
                }

                <Button
                    onClick={() => props.openModalWeigthTable()}
                >
                    Tabela de Pesos
                </Button>

                <Divider />

                <Tabs defaultActiveKey="1">
                    <Tabs.TabPane tab="Checagem Geral" key="1">
                        {
                            props.champId ?
                                <CompetitorsList
                                    champId={props.champId}
                                    competitorsList={props.competitorsList}
                                /> : null
                        }
                    </Tabs.TabPane>

                    <Tabs.TabPane tab="Chaves" key="2">
                        {
                            props.champId ?
                                <SwitchingsList
                                    champId={props.champId}
                                /> : null
                        }
                    </Tabs.TabPane>

                    <Tabs.TabPane tab="Cronograma" key="3">
                        <ScheduleContainer
                            champObject={props.champ}
                            champId={props.champId}
                        />
                    </Tabs.TabPane>

                </Tabs>
            </div>

            {/* Registration Modal */}
            <Modal
                title='Inscrição'
                visible={props.modalRegistration}
                onCancel={props.closeModalRegistration}
                width='600px'
                footer={[
                    <Button key='close' onClick={props.closeModalRegistration}>Fechar</Button>
                ]}
            >
                <RegistrationForm
                    arrayOfTeams={props.arrayOfTeams}
                    champInfo={props.champ}
                    champId={props.champId}
                    quadroDePesos={props.quadroDePesos}
                    updateStudentList={() => props.updateStudentList()}
                />
            </Modal>

            {/* Weigth table modal */}
            <Modal
                visible={props.modalWeigthTable}
                title='Tabela de pesos'
                onCancel={props.closeModalWeigthTable}
                width={800}
                footer={[]}
            >
                <div style={{ width: '100%', height: '400px', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundImage: `url(${weigthTableImg})` }}></div>
            </Modal>
        </div>
    );
}